import { RootState } from '../../../app/reducer';
import { PodcastEpisodeModel, PodcastModel } from '../../../models/Podcast.model';

export const selectCurrentPodcast = ({
  currentPodcastReducer,
}: RootState): PodcastModel => currentPodcastReducer.currentPodcast;

export const selectCurrentEpisode = ({
  currentPodcastReducer,
}: RootState): PodcastEpisodeModel => currentPodcastReducer.currentEpisode;

export const selectPlayerRate = ({ currentPodcastReducer }: RootState): number =>
  currentPodcastReducer.playerRate;

export const selectIsPodcastPlayerModalVisible = ({
  currentPodcastReducer,
}: RootState): boolean => currentPodcastReducer.isPodcastPlayerModalVisible;
